// src/features/editor/components/blocks/DisabledBlockPlaceholder.tsx
import { Lock, Trash2 } from 'lucide-react'
import { Button } from '@teach/ui'
import { useMessages } from '@/i18n'
import { messages } from './messages'

interface Props {
  typeName: string
  isCourseAuthor: boolean
  onDelete: () => void
}

export const DisabledBlockPlaceholder = ({ typeName, isCourseAuthor, onDelete }: Props) => {
  const m = useMessages(messages)
  return (
    <div className="flex flex-col items-center justify-center gap-3 p-8 text-center">
      <Lock className="h-12 w-12 text-muted-foreground" />
      <div className="space-y-1">
        <p className="text-sm font-medium">{m.notAvailableYet}</p>
        <p className="text-xs text-muted-foreground">
          {m.disabledTypePrefix}{' '}
          <code className="rounded bg-muted px-1.5 py-0.5 font-mono text-[11px]">{typeName}</code>{' '}
          {m.disabledTypeSuffix}
        </p>
      </div>
      <Button
        variant="destructive"
        size="sm"
        onClick={onDelete}
        disabled={!isCourseAuthor}
        title={!isCourseAuthor ? m.noRights : undefined}
      >
        <Trash2 className="mr-2 h-4 w-4" />
        {m.deleteBlock}
      </Button>
    </div>
  )
}
